import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { Login } from "./login";
import { ResetPassword } from "./forgetPassword";
import { AppThemeProvider } from "./_shared/styles/ThemeProvider";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import store from "./store";
import { Layout } from "./_shared/layout";
import LandingPage from "./landingPage";
import { ErrorProvider } from "./_shared/context/ErrorContext";
import { useEffect } from "react";
import * as loginRoutes from './_shared/routing'
import {getEnvVar} from "@delorean/utils/env-utils";
import { loadCaptchaScript } from "./_shared/hooks/useCaptcha";


function App() {
  useEffect(() => {
    console.log(`App Version: ${getEnvVar('VITE_APP_VERSION')}`);
  }, []);


  useEffect(() => {
    const googleCaptchaKey = getEnvVar('VITE_CAPTCHA_KEY');
    const seapUrl = getEnvVar('VITE_SEAP_URL');
    const dynatraceUrl = getEnvVar('VITE_DYNATRACE_URL');

    // ogni script viene caricato in modo indipendente: la mancanza di uno
    // non deve impedire il caricamento degli altri (es. reCAPTCHA)
    const scripts: HTMLScriptElement[] = [];

    if (googleCaptchaKey) {
      scripts.push(loadCaptchaScript(googleCaptchaKey));
    }

    if (seapUrl) {
      const seapScript = document.createElement("script");
      seapScript.src = seapUrl;
      seapScript.async = true;
      seapScript.onload = () => console.log('SEAP script loaded successfully');
      document.body.appendChild(seapScript);
      scripts.push(seapScript);
    }

    if (dynatraceUrl) {
      const dynatraceScript = document.createElement("script");
      dynatraceScript.src = dynatraceUrl;
      dynatraceScript.type = "text/javascript";
      dynatraceScript.crossOrigin = "anonymous";
      dynatraceScript.onload = () => console.log('Dynatrace script loaded successfully');
      document.head.appendChild(dynatraceScript);
      scripts.push(dynatraceScript);
    }

    return () => {
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <ErrorProvider>
      <Provider store={store}>
        <Router basename={`${getEnvVar('VITE_HOMEPAGE_URL')}`}>
         {/*  <AppThemeProvider> */}
            <IntlProvider locale="it">
              <Layout>
                <Routes>
                  <Route
                    path="*"
                    element={<Navigate to={loginRoutes.authorize} replace />}
                  />
                  <Route path={loginRoutes.authorize} element={<LandingPage />} />
                  <Route path={loginRoutes.login} element={<Login />} />
                  <Route path={loginRoutes.resetPassword} element={<ResetPassword />} />
                </Routes>
              </Layout>
            </IntlProvider>
        {/*   </AppThemeProvider> */}
        </Router>
      </Provider>
    </ErrorProvider>
  );
}

export default App;
